import { Grid } from "capitalrx-components-2.0/lib/layout";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";

import styles from "./AffordableHealthCare.module.scss";

const AffordableHealthCare = (): JSX.Element => {
  return (
    <div className={styles.AffordableHealthWrapper} data-testid="affordable-health-section">
      <Grid>
        <Grid className={styles.AffordableHealthContent}>
          <div className={styles.AffordableHealthTitle}>We believe in affordable healthcare.</div>
          <Paragraph className={styles.AffordableHealthBody} textAlign="center">
            Capital Rx has eliminated the high fees and hidden drug mark-ups in other well-known discount programs to deliver a better Rx.
          </Paragraph>
        </Grid>
      </Grid>
    </div>
  );
};

export default AffordableHealthCare;
